import Resource, {BaseResource} from './Resource';

/**
 * Archived Deal Resource
 */
class ArchivedDeal extends Resource
{
    constructor() {
        super('archived.deal', ['archived-deals']);
    }

    search(query, params = {}, config = {}) {
      params = Object.assign(params, { query });

      return this._doGet(['search'], params, config);
    }

    options(params) {
        return this._doGet(['options'], params);
    }
}

export let ArchivedDealResource = new ArchivedDeal();